import { useState } from "react";
import type { FC, ReactNode } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import { Box, Button, Collapse, ListItem } from "@material-ui/core";
import type { ListItemProps } from "@material-ui/core";
import ChevronDownIcon from "../../icons/ChevronDown";
import ChevronRightIcon from "../../icons/ChevronRight";

interface NavItemProps extends ListItemProps {
  active?: boolean;
  children?: ReactNode;
  depth: number;
  // icon?: ReactNode;
  info?: ReactNode;
  open?: boolean;
  path?: string;
  title: string;
}

const NavItem: FC<NavItemProps> = (props) => {
  const {
    active,
    children,
    depth,
    // icon,
    info,
    open: openProp,
    path,
    title,
    ...other
  } = props;
  const [open, setOpen] = useState<boolean>(openProp);
  const theme = useTheme();
  const handleToggle = (): void => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 22 + 8 * depth;
  }

  // Branch
  if (children) {
    return (
      <ListItem
        disableGutters
        sx={{
          display: "block",
          py: 0,
          "& :hover": {
            borderRadius: "0px !important",
          },
        }}
        {...other}
      >
        <Button
          endIcon={
            title &&
            (!open ? (
              <ChevronRightIcon fontSize="small" />
            ) : (
              <ChevronDownIcon fontSize="small" />
            ))
          }
          onClick={handleToggle}
          // startIcon={icon}
          sx={{
            // color: 'text.primary',
            // color: 'rgb(107, 119, 140)',
            color:
              theme.palette.mode === "dark" ? "#FFFFFF" : "rgb(107, 119, 140)",
            fontWeight: "fontWeightMedium",
            // borderRadius: '0px',
            justifyContent: "flex-start",
            pl: title ? `${paddingLeft}px` : "14px",
            pr: "15px",
            // py: '8px',
            textAlign: "left",
            textTransform: "none",
            width: "100%",
          }}
          variant="text"
        >
          <Box sx={{ flexGrow: 1 }}>{title}</Box>
          {info}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  // Leaf
  return (
    <ListItem
      disableGutters
      sx={{
        display: "flex",
        py: 0,
        // borderRadius: 0,
        "& :hover": {
          color: "primary.text.secondary",
          backgroundColor: "primary.text.secondary",
          borderRadius: "0px !important",
        },
      }}
    >
      <Button
        component={path && RouterLink}
        // startIcon={icon}
        sx={{
          // borderRadius: 0,
          // color: 'text.primary',
          // color: 'rgb(107, 119, 140)',
          color: "black",
          // color: theme.palette.mode === 'dark' ? '#FFFFFF' : 'rgb(107, 119, 140)',
          fontWeight: "fontWeightMedium",
          justifyContent: "flex-start",
          textAlign: "left",
          pl: title ? `${paddingLeft}px` : "14px",
          pr: "8px",
          py: "8px",
          textTransform: "none",
          width: "100%",
          mb: "2px",
          ...(active && {
            // color: 'primary.contrastText',
            backgroundColor: "#f4f5f7",
            "&:hover": {
              backgroundColor: "#f4f5f7 !important",
            },
            // width: title ?'75%',
            minWidth: "20px",
            // background: 'linear-gradient(180deg, #50B4EC 0%, #22A0E7 100%)',
            borderRadius: "0px !important",
            color: theme.palette.text.primary,
            // color: 'primary.main',
            "& svg": {
              color: "primary.main",
            },
          }),
        }}
        variant={active ? "contained" : "text"}
        // to={`${path}?title=${title}`}
        to={path}
        // to={{
        //   pathname: path + '?title=' + title
        //   // String: title
        // }}
      >
        <Box sx={{ flexGrow: 1 }}>{title}</Box>
        {info}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  // icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  active: false,
  open: false,
};

export default NavItem;
